<app-header (filterChange)="onCategoryFilterChange($event)" (brandFilterChange)="onBrandFilterChange($event)"
  (openFilterChange)="onOpenFilterChange($event)" (searchFilterChange)="onSearchFilterChange($event)">
</app-header>

<div class="catlog-page">
  <div class="d-flex justify_sb" style="margin-bottom:6px;">
    <div *ngIf="breadCrumFlag">
      <ul class="breadcrumb">

        <li *ngFor="let item of sortedCategoryHierarchy;let i=index">
          <span>{{ item.value }}</span>
          <i *ngIf="i!=sortedCategoryHierarchy.length-1" class="ri-arrow-right-s-line"></i>
        </li>
      </ul>
    </div>
    <div class="d-flex">
      <div class="filter-col d-flex">
        <mat-slide-toggle [(ngModel)]="supplierAvailable" #toggleEl [color]="viewEnabledFilter ? 'red' : 'warn'"
          (change)="toggleSupplierAvailable($event)"></mat-slide-toggle>
        <mat-label>Supplier Available </mat-label>
      </div>&nbsp;&nbsp;
      <div class="filter-col d-flex ml-10">
        <mat-slide-toggle [(ngModel)]="viewEnabledFilter" #toggleEl [color]="viewEnabledFilter ? 'red' : 'warn'"
          (change)="toggleFunction($event)"></mat-slide-toggle>
        <mat-label>Standard Products </mat-label>
      </div>
      <button class="slider-toggle-btn ml-10" (click)="togglePanel()"><i class="ri-arrow-left-double-fill"
          class="text-truncate"
          [ngClass]="{'ri-arrow-right-double-fill': isOpen, 'ri-arrow-left-double-fill': !isOpen}"></i>
        <span> {{accodainResponse.categoryName}}</span>
      </button>
    </div>
  </div>
  <!-- <div class="d-flex justify_sb">
    <h2 *ngIf="breadCrumFlag" class="page-heading">
      Showing results <span *ngIf="searchOpenString">for {{searchOpenString}} </span>in {{
      showCategoryName }} <span style="font-size: small;">(Showing {{dataSource.data.length}} results...)</span>
    </h2>
    <div class="col d-flex">
      <mat-label>Filter Product </mat-label>
      <mat-slide-toggle [(ngModel)]="viewEnabledFilter" #toggleEl [color]="viewEnabledFilter ? 'red' : 'warn'"
        (change)="toggleFunction($event)"></mat-slide-toggle>
    </div>
  </div> -->
  <div *ngIf="MatTabCategoryListFlag">
    <mat-tab-group class="cate-tabs" animationDuration="0ms" mat-align-tabs="start" #tabGroup
      [(selectedIndex)]="activeTabIndex">



      <mat-tab *ngFor="let category of MatTabCategoryList" [label]="category"
        [ngClass]="{ 'highlight-tab': shouldHighlightFirstTab }">
        <ng-template mat-tab-label>
          <div class="ctg_tab" (click)="onTabClick(category.categoryCode,category.categoryName,true)">{{
            category.categoryName }} ({{ category.productCount
            }})</div>

        </ng-template>
      </mat-tab> </mat-tab-group>

    <div class="side-panel" [ngClass]="{'open': isOpen}">

      <button *ngIf="isOpen" class="slider-toggle-btn-2 ml-10" (click)="togglePanel()">
        <i class="ri-arrow-right-double-fill"></i>
      </button>
      <span class="item-name"> {{accodainResponse.categoryName}} </span>
      <div class="accordion-height" [innerHTML]="accodainDescription"></div>
    </div>
    <div class="overlay-container">
      <!-- Your content goes here -->
      <div *ngIf="isOpen" class="overlay"></div>
    </div>
    <!-- Add accordion component here -->
    <!-- <div *ngIf="accordainFlag" class="accordian">

          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <span class="item-name"> {{accodainResponse.categoryName}} </span>
              </mat-expansion-panel-header>
              <div class="accordion-height" [innerHTML]="accodainDescription"></div>
            </mat-expansion-panel>
          </mat-accordion>
        </div> -->

    <div class="input-area">
      <!-- Brand Filter -->
      <button class="scroll-btn scroll-left" *ngIf="checkOverflow(scrollContainer)" (click)="scrollLeft()"><i
          class="ri-arrow-left-s-line"></i></button>
      <div #scrollContainer class="overflow-list scrollbar-1">

        <div class="list">
          <div class="formfield">

            <label>Brand Filter</label>
            <mat-form-field appearance="outline" class="mog3-matselect h-32">
              <mat-select (focus)="focusInputBrand()" disableOptionCentering
                [placeholder]="brandFilterOptions?.Brand.length === 0 ? 'Not available' : 'Select Brand'"
                [disabled]="brandFilterOptions?.Brand.length === 0" [formControl]="brandFilterControl" multiple
                #selectTrigger (ngModelChange)="onBrandFiltercatChange($event)">

                <mat-form-field class="mog3_matinput select-search" appearance="outline">
                  <input #myInput matInput placeholder="Search Brand" [(ngModel)]="searchInput" />
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                    <path
                      d="M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z"
                      fill="rgba(111,111,112,1)"></path>
                  </svg>
                </mat-form-field>
                <div class="custom-panel">
                  <mat-option *ngFor="let brand of brandFilterOptions?.Brand | filter:searchInput"
                    [value]="brand.brandCode"> {{ brand.brandName }} <span style="color: blue;">({{
                      brand.productCount}})</span></mat-option>
                </div>
                <div class="filter-btn-section">
                  <button class="filter-btn clear" (click)="clearBrandFilter()">Clear</button>
                  <button class="filter-btn apply" (click)="applyFilters()">Apply</button>
                </div>
              </mat-select>
            </mat-form-field>

          </div>

          <!-- Other Filters -->
          <div class="formfield" *ngFor="let template of productData?.data?.viewFilterTemplate;let i = index">

            <ng-container *ngIf="template.attributeName !== 'Brand'">
              <label>{{ template.attributeName }}</label>
              <mat-form-field appearance="outline" class="mog3-matselect h-32">
                <mat-select disableOptionCentering [formControl]="otherFiltersControl[template.attributeName]" multiple
                  [placeholder]="brandFilterOptions[template.attributeName]?.length === 0 ? 'Not available' : 'Select ' + template.attributeName"
                  [disabled]="brandFilterOptions[template.attributeName]?.length === 0"
                  (click)="clearSearchInput(template.attributeName)" (focus)="focusInputAll(i)">
                  <mat-form-field class="mog3_matinput select-search" appearance="outline">
                    <input #myInput2 matInput [(ngModel)]="searchInput1" name="searchInput1"
                      placeholder="Search  {{template?.attributeName}}" (input)="filterOptions(template.attributeName)"
                      (keydown)="handleSpaceKey($event)" />
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                      <path
                        d="M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z"
                        fill="rgba(111,111,112,1)"></path>
                    </svg>
                  </mat-form-field>
                  <div class="custom-panel">
                    <mat-option *ngFor="let option of filteredOptions[template.attributeName];let i=index"
                      [value]="option">
                      {{ option }}</mat-option>
                  </div>
                  <div class="filter-btn-section">
                    <button class="filter-btn clear" (click)="clearOtherFilter(template.attributeName)">Clear</button>
                    <button class="filter-btn apply" (click)="applyDynamicFilters()">Apply</button>
                  </div>
                </mat-select>
              </mat-form-field>
            </ng-container>

          </div>
        </div>
      </div>

      <button class="scroll-btn scroll-right" *ngIf="checkOverflow(scrollContainer)" (click)="scrollRight()">
        <i class="ri-arrow-right-s-line"></i>
      </button>
      <div class=" d-flex justify_fe">
        <!-- <button mat-flat-button class="mog3_primary_border_btn" (click)="clearAllFilters()">
              Clear All
            </button> -->


        <div class="flex align-center ">
          <button title="clear all" mat-button class="btn-basic btn-circle btn-md ml-10 mr-10"
            (click)="clearAllFilters()" color="Black"><i class="ri-loop-right-fill"></i></button>


          <button title="view full information" mat-button class="btn-basic btn-circle btn-md " (click)="toggleChange()"
            color="Black">
            <img [src]="ToggleimageSource" alt="">
          </button>
        </div>





      </div>
    </div>
    <div class="w-100max" *ngIf="dataLoaded">
      <section class="mog3_msnsearchtable result-table" tabindex="0" infiniteScroll [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="8" (scrolled)="onScroll(category)" [infiniteScrollDisabled]="isFullListDisplayed"
        [scrollWindow]="false">
        <!-- <section class="mog3_msnsearchtable result-table" tabindex="0" [style.height.px]="tableHeight"> -->
        <table mat-table [dataSource]="dataSource">
          <!-- Combined columns -->
          <ng-container matColumnDef="Product ID/Name" sticky>
            <th mat-header-cell *matHeaderCellDef>Product ID/Name</th>
            <td mat-cell *matCellDef="let element">
              <div class="d-flex align-start">


                <div>
                  <img class="product-image" src="{{imgPrefix}}{{element['mainImagePath']}}" alt="no-img"
                    onerror="this.src='../../../assets/img/NoImg.png'">
                       <span class="font-500 d-flex font-9px" [ngStyle]="{ color: getColor() }">
                      &nbsp;{{ element['enterpriseType'] }}
                    </span>
                </div>
                <div class="msn-column-width" >
                  <div class="d-flex align-center justify-between">

                 
                  <span class="font-500 d-flex align-items-center">
                    {{ element['moglixPartNumber'] }}
                  </span>
                    <span  class="copy-icon-button mr-10"
                      (click)="copyToClipboard(element['moglixPartNumber'], copyTooltip)" matTooltip="Copy MSN"
                      #copyTooltip="matTooltip" matTooltipPosition="above">
                   <i class="ri-file-copy-line"></i>
                    </span>
                     </div>
                  <!-- <span class="font-500 d-flex"  [ngStyle]="{ color: getColor() }">- {{ element['enterpriseType'] }}</span> -->
                  <span class="link text-truncate" [ngClass]="{'': isToggled, 'text-truncate': !isToggled}"
                    (click)="productDetails(element['moglixPartNumber'],element['supplierAvailable'])">{{
                    element['productName'] }}
                  </span>
                </div>
              </div>


              <!-- <div>
                      <a [href]="urls.slink + element['mainImagePath']" target="_blank">
                        <img [src]="urls.slink + element['mainImagePath']+ '/image.jpg'" alt="My Image">
                      </a>
                    </div> -->
              <!-- const imageLink = element['mainImagePath']; -->

            </td>
          </ng-container>
          <ng-container matColumnDef="Brand Name">
            <th mat-header-cell *matHeaderCellDef>Brand Name</th>
            <td mat-cell *matCellDef="let element">
              {{ element['brandDisplayName'] }}
            </td>
          </ng-container>



          <!-- Other dynamic columns -->
          <ng-container *ngFor="let column of displayColumns | keyvalue; let i = index">
            <ng-container>
              <ng-container [matColumnDef]="column.value">
                <th mat-header-cell *matHeaderCellDef>{{column.value}}</th>
                <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="element.attributeList">

                    <span class="text-truncate" [ngClass]="{'': isToggled, 'text-truncate': !isToggled}"
                      title="{{ element.attributeList[column.key] }}">{{element.attributeList[column.key]}}</span>
                  </ng-container>

                  <ng-container *ngIf="!element.attributeList">
                    <span>-</span>
                  </ng-container>
                </td>
              </ng-container>
            </ng-container>
          </ng-container>


          <!-- <ng-container *ngFor="let column of displayedColumns; let i = index">
                <ng-container
                  *ngIf="column !== 'viewSupplier' && column !== 'itemsInPack/Uom' && column !== 'Product ID/Name' && column !== 'Brand Name' && column !== 'MRP' && column !== 'LP/LPDate' && column !== 'lp' && column !== 'moglixPartNumber' && column !== 'productName' else otherColumns">
                  <ng-container [matColumnDef]="column">
                    <th mat-header-cell *matHeaderCellDef>{{column}}</th>
                    <td mat-cell *matCellDef="let element">
                      <ng-container *ngIf="element.attributeList">
                        <ng-container *ngFor="let ac of attributeColumns; let i = index">
                          <ng-container *ngIf="column === ac.attributeName">
                            <div class="tooltip-div">
                            <span>{{element.attributeList[ac.key ]}}</span>
                              <div></div>
                              <div class="tooltip-absolute">
                                <span class="tooltiptext">{{element.attributeList[ac.key ]}}</span>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="column !== ac.attributeName">
                            <span></span>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="!element.attributeList">
                        <span>-</span>
                      </ng-container>
                    </td>
                  </ng-container>
                </ng-container>
              </ng-container> -->

          <ng-container matColumnDef="itemsInPack/Uom" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>Items in Pack<br />UOM</th>
            <td mat-cell *matCellDef="let element">
              <span>{{ element['itemsInPack'] }}</span>
              <span style="display: block;">{{ element['uom']}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="MRP" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>MRP<br /><span class="header-placeholder"> (dd/mm/yy)</span></th>
            <td mat-cell *matCellDef="let element">
              <span class="link" *ngIf="element['mrp']['INDIA']!=0">₹{{ element['mrp']['INDIA'] }}</span>
              <span class="link" *ngIf="element['mrp']['INDIA']==0">-</span><br />
              <span>{{ element.mrpDateStr }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="LP/LPDate" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>List Price<br />
              <span class="header-placeholder"> (mm/dd/yy)</span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element['lp']!=0" style="color: #125EAD;">₹{{ element['lp'] }}</span>
              <span style="display: block;">{{ element['lpDate'] }} </span>

              <span *ngIf="element['lp']==0 && element['lpDate']==null">-</span>
            </td>

          </ng-container>

          <ng-container matColumnDef="tp/txn_date" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>TP Txn <br /><span class="header-placeholder"> (yy/mm/dd)</span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span style="display: block;color: #125EAD;">{{ element['tp'] }} </span>
              <span style="margin-bottom: 5px;display: block;" *ngIf="element['supplierAvailable']!=true">-</span>

              <span style="color: #125EAD;display: block;">{{ element['txn_date'] }}</span>
              <span style="display: block;" *ngIf="element['supplierAvailable']!=true">-</span>

            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="tp/txn_date" stickyEnd>
                <th mat-header-cell *matHeaderCellDef>Txn Date
                 <span class="header-placeholder">(yyyy/mm/dd)</span>
                </th>
                <td mat-cell *matCellDef="let element">
                  <span  style="color: #125EAD;">{{ element['txn_date'] }}</span>
                  <span *ngIf="element['supplierAvailable']!=true">-</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="tp" stickyEnd>
                <th mat-header-cell *matHeaderCellDef>TP
                </th>
                <td mat-cell *matCellDef="let element">
                  <span style="display: block;color: #125EAD;">{{ element['tp'] }} </span>
                  <span *ngIf="element['supplierAvailable']!=true">-</span>
                </td>
              </ng-container> -->

          <ng-container matColumnDef="viewSupplier" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element" class="vertical-middle">
              <button class="red-border-btn"
                (click)="productSupplier(element['moglixPartNumber'],element['supplierAvailable'])"
                [attr.data-supplier-available]="element['supplierAvailable'] ? 'true' : 'false'"
                [disabled]="element?.supplierCount==0">
                <span *ngIf="element.supplierCount!=0">{{element?.supplierCount}} Suppliers</span>
                <span *ngIf="element.supplierCount==0">No Suppliers</span>
              </button>
              <a class="blue-anchor"
                (click)="onVariantClick(element?.categoryCodes, element?.brandId, element?.cisIdGroup, element?.moglixPartNumber)"
                [ngClass]="{'disable-link ': element.variantCount==0}">
                <span *ngIf="element.variantCount==0 || element.variantCount==null"> No Variants </span>
                <span *ngIf="element.variantCount!=0">{{element?.variantCount}} Variants</span>
              </a>
            </td>
          </ng-container>
          <!-- Table rows -->
          <tr mat-header-row *matHeaderRowDef="staticColumns;sticky:true"></tr>
          <tr mat-row *matRowDef="let row; columns: staticColumns"></tr>
        </table>
      </section>

      <div class="d-flex justify_sb">
        <h2 *ngIf="breadCrumFlag" class="page-heading-small">
          Showing results <span *ngIf="searchOpenString">for {{searchOpenString}} </span>in {{
          showCategoryName }} <span>(Showing {{dataSource.data.length}} results...)</span>
        </h2>

      </div>
    </div>
    <div *ngIf="!dataLoaded">
      <span *ngIf="!dataLoaded && products.length>0">Loading data...</span>
      <span *ngIf="!dataLoaded && products.length===0">Loading data...</span>
    </div>
    <!-- </mat-tab>
    </mat-tab-group> -->
  </div>